import React, { useState } from 'react';
import { X, SlidersHorizontal } from 'lucide-react';

export default function FilterSidebar({ filters, locations, categories, onApply, onReset }) {
  const [local, setLocal] = useState(filters || {});
  const [sheetOpen, setSheetOpen] = useState(false);

  const update = (key, val) => setLocal((p) => ({ ...p, [key]: val }));

  const handleApply = () => {
    onApply(local);
    setSheetOpen(false);
  };

  const handleReset = () => {
    setLocal({});
    onReset();
    setSheetOpen(false);
  };

  const FiltersContent = () => (
    <div className="space-y-5" data-testid="filters-sidebar">
      <div>
        <p className="text-xs uppercase tracking-widest mb-2" style={{ color: 'var(--mi-text)' }}>Categoria</p>
        <select
          data-testid="filters-category-select"
          value={local.categoria || ''}
          onChange={(e) => update('categoria', e.target.value)}
          className="w-full h-9 px-3 rounded-lg border text-sm bg-white"
          style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)' }}
        >
          <option value="">Tutte le categorie</option>
          {categories?.map((c) => (
            <option key={c.slug} value={c.slug}>{c.nome} ({c.count})</option>
          ))}
        </select>
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest mb-2" style={{ color: 'var(--mi-text)' }}>Città</p>
        <select
          data-testid="filters-city-select"
          value={local.citta || ''}
          onChange={(e) => update('citta', e.target.value)}
          className="w-full h-9 px-3 rounded-lg border text-sm bg-white"
          style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)' }}
        >
          <option value="">Tutte le città</option>
          {locations?.citta?.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest mb-2" style={{ color: 'var(--mi-text)' }}>Provincia</p>
        <select
          data-testid="filters-province-select"
          value={local.provincia || ''}
          onChange={(e) => update('provincia', e.target.value)}
          className="w-full h-9 px-3 rounded-lg border text-sm bg-white"
          style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)' }}
        >
          <option value="">Tutte le province</option>
          {locations?.province?.map((p) => (
            <option key={p.codice} value={p.codice}>{p.nome} ({p.codice})</option>
          ))}
        </select>
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest mb-2" style={{ color: 'var(--mi-text)' }}>Regione</p>
        <select
          data-testid="filters-region-select"
          value={local.regione || ''}
          onChange={(e) => update('regione', e.target.value)}
          className="w-full h-9 px-3 rounded-lg border text-sm bg-white"
          style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)' }}
        >
          <option value="">Tutte le regioni</option>
          {locations?.regioni?.map((r) => (
            <option key={r} value={r}>{r}</option>
          ))}
        </select>
      </div>
      <div className="pt-2 flex flex-col gap-2">
        <button
          data-testid="filters-apply-button"
          onClick={handleApply}
          className="w-full h-10 rounded-xl text-sm font-medium transition-colors"
          style={{ backgroundColor: 'var(--mi-fg)', color: 'var(--mi-bg)' }}
        >
          Applica filtri
        </button>
        <button
          data-testid="filters-reset-button"
          onClick={handleReset}
          className="w-full h-10 rounded-xl border text-sm font-medium transition-colors hover:bg-gray-50"
          style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-text)' }}
        >
          Reimposta
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile filter button */}
      <div className="lg:hidden mb-4">
        <button
          data-testid="filters-open-sheet-button"
          onClick={() => setSheetOpen(true)}
          className="flex items-center gap-2 px-4 h-10 rounded-xl border text-sm font-medium"
          style={{ borderColor: 'var(--mi-border)', backgroundColor: '#fff', color: 'var(--mi-fg)' }}
        >
          <SlidersHorizontal size={14} />
          Filtri
        </button>
      </div>

      {/* Mobile Sheet */}
      {sheetOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex flex-col" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div
            className="mt-auto p-6 rounded-t-2xl max-h-[85vh] overflow-y-auto"
            style={{ backgroundColor: 'var(--mi-bg)' }}
          >
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-display text-lg">Filtri</h3>
              <button onClick={() => setSheetOpen(false)}><X size={18} /></button>
            </div>
            <FiltersContent />
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <div
        className="hidden lg:block p-5 rounded-2xl border bg-white lg:sticky"
        style={{ borderColor: 'var(--mi-border)', top: '84px' }}
      >
        <p className="font-display text-base mb-4">Filtri</p>
        <FiltersContent />
      </div>
    </>
  );
}
